import { render, staticRenderFns } from "./reserve_finish.vue?vue&type=template&id=143e00c8&"
import script from "./reserve_finish.vue?vue&type=script&lang=js&"
export * from "./reserve_finish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports